import React, { useState, useEffect } from 'react';
import Loader from "../Shared/Loader/Loader";
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import userImage from '../../assets/images/UserImage.png';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useCatchResponse } from '../../utils/useCatchResponse';
import { Calendar } from 'primereact/calendar';
import { apiBase } from '../../utils/config';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const Attendance = () => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [classList, setClassList] = useState([]);
    const [classWiseAttendanceList, setClassWiseAttendanceList] = useState([]);
    const [studentWiseAttendanceList, setStudentWiseAttendanceList] = useState([]);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [selectedClass, setSelectedClass] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date);
    const [classTime, setClassTime] = useState('');
    const [isStudentView, setIsStudentView] = useState(false);
    const [attendanceList, setAttendanceList] = useState([]);
    const [childRows, setChildRows] = useState(10);
    const [childFirst, setChildFirst] = useState(0);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        const childId = CommonConfig.getCookie('selected_childId');
        GetClassList(childId ?? loginData?._id);
    }, []);

    const onChildPageChange = (e) => {
        setChildFirst(e.first);
        setChildRows(e.rows);
    };

    const GetClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        value: x?._id,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    })));
                    if (res?.data.length) {
                        setSelectedClass(res?.data[0]?._id);
                        GetClassWiseAttendanceList(res?.data[0]?._id, selectedDate);
                        GetStudentWiseAttendanceList(res?.data[0]?._id, selectedDate);
                    }
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const formatDateToYMD = (dateObj) => {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    };

    const GetClassWiseAttendanceList = async (id, date) => {
        try {
            let formattedDate = formatDateToYMD(date);
            let data = {
                ClassId: id,
                SelectedDate: formattedDate,
            }
            Loader.show();
            await api.post(APIConstant.path.GetClassWiseAttendanceList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassWiseAttendanceList(res.data);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetStudentWiseAttendanceList = async (id, date) => {
        try {
            let formattedDate = formatDateToYMD(date);
            let data = {
                ClassId: id,
                SelectedDate: formattedDate,
            }
            Loader.show();
            await api.post(APIConstant.path.GetStudentWiseAttendanceList, data).then(async response => {
                let res = response;
                if (res.success) {
                    const sortedData = res.data.sort((a, b) => {
                        const rollA = parseInt(a?.RollNo) || 0;
                        const rollB = parseInt(b?.RollNo) || 0;

                        if (rollA !== rollB) {
                            return rollA - rollB; 
                        }

                        const startTimeA = (a?.ClassTime || '').split(' - ')[0];
                        const startTimeB = (b?.ClassTime || '').split(' - ')[0];

                        const dateA = new Date(`1970-01-01 ${startTimeA}`);
                        const dateB = new Date(`1970-01-01 ${startTimeB}`);

                        return dateA - dateB;
                    });

                    setStudentWiseAttendanceList(sortedData);
                }
                Loader.hide();
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return date.toLocaleString('en-US', options).replace(',', '');
    }

    const attendanceDateBodyTemplate = (rows) => {
        return <div>{!CommonConfig.isEmpty(rows?.AttendanceDate) ? formatDate(rows?.AttendanceDate) : '--'}</div>
    };

    const attendanceBodyTemplate = (rows) => {
        return (
            <label htmlFor="attendance"
                style={{
                    color: rows?.AttendanceType === 'P' ? 'green' : rows?.AttendanceType === 'L' ? 'yellow' : 'red',
                    fontWeight: "bold",
                    cursor: "pointer",
                }}
            >
                {rows?.AttendanceType}
            </label>
        )
    };

    const attendanceActionBodyTemplate = (rows) => {
        return (
            <label htmlFor="attendance"
                style={{
                    color: 'green',
                    fontWeight: "bold",
                    cursor: "pointer",
                }}
                onClick={() => {
                    setClassTime(rows?.ClassTime);
                    debugger
                    const attendanceData = studentWiseAttendanceList?.filter(y => y?.ClassTime === rows?.ClassTime && y?.SubjectName === rows?.SubjectName);
                    console.log('hfhfhf: ', attendanceData);

                    setAttendanceList(attendanceData);
                    setIsStudentView(true)
                }}
            >
                {rows?.Attendance}
            </label>
        )
    };

    const handleClassChange = (value) => {
        setSelectedClass(value);
        GetClassWiseAttendanceList(value, selectedDate);
        GetStudentWiseAttendanceList(value, selectedDate)
    }

    const handleDateChange = (value) => {
        setSelectedDate(value);
        GetClassWiseAttendanceList(selectedClass, value);
        GetStudentWiseAttendanceList(selectedClass, value)
    }

    const studentNameWithImageTemplate = (rowData) => {
        const imageUrl = rowData?.ProfilePic
            ? `${apiBase}/UserProfilePic/${rowData?.ProfilePic}`
            : userImage;

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                    src={imageUrl}
                    alt={rowData.StudentName}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userImage;
                    }}
                    style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                    }}
                />
            </div>
        );
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
            />
        </div>
    );

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-eye"></i>
                    <h2>View Attendance</h2>
                </div>
                <div className="p-grid p-align-center">
                    <label htmlFor="attendanceDate">Attendance Date </label>
                    <div className='searchbar-area'>
                        <Calendar
                            className='p-w-100 p-mt-0'
                            id="attendanceDate"
                            value={selectedDate}
                            hourFormat="12"
                            dateFormat="dd/mm/yy"
                            onChange={(e) => handleDateChange(e.value)}
                        />
                    </div>
                    <div style={{ marginBottom: '10px', marginTop: '10px' }}>
                        <Dropdown
                            value={selectedClass}
                            options={classList}
                            onChange={(e) => handleClassChange(e.value)}
                            placeholder="Select Class"
                            filter showClear
                        />
                    </div>
                </div>
            </div>
            <div className='e-tab-main'>
                <TabView>
                    <TabPanel header="Class Wise Attendance">
                        <div>
                            <DataTable
                                value={classWiseAttendanceList}
                                paginator
                                rows={rows}
                                first={first}
                                filterDisplay="menu"
                                responsiveLayout="scroll"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                rowsPerPageOptions={[5, 10, 20]}
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                onPage={onPageChange}
                                className='custom-table'
                                scrollHeight='calc(100vh - 185px)'
                                size='small'
                            >
                                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." />
                                <Column
                                    field="ClassName"
                                    header="Class Name"
                                />
                                <Column
                                    field="ClassTime"
                                    header="Class Time"
                                />
                                <Column
                                    field="SubjectName"
                                    header="Subject Name"
                                />
                                <Column
                                    body={attendanceDateBodyTemplate}
                                    header="Submitted On"
                                />
                                <Column
                                    field='TakenBy'
                                    header="Submitted By"
                                />
                                <Column
                                    field='Attendance'
                                    header="Attendance"
                                    body={attendanceActionBodyTemplate}
                                />
                            </DataTable>
                        </div>
                    </TabPanel>
                    <TabPanel header="Student Wise Attendance">
                        <div>
                            <DataTable
                                value={studentWiseAttendanceList}
                                paginator
                                rows={rows}
                                first={first}
                                filterDisplay="menu"
                                responsiveLayout="scroll"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                rowsPerPageOptions={[5, 10, 20]}
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                onPage={onPageChange}
                                className='custom-table'
                                scrollHeight='calc(100vh - 185px)'
                                size='small'
                            >
                                <Column field="RollNo" header="Roll No." />
                                <Column
                                    field="ClassName"
                                    header="Class Name"
                                />
                                <Column
                                    field="ClassTime"
                                    header="Class Time"
                                />
                                <Column
                                    field="SubjectName"
                                    header="Subject Name"
                                />
                                <Column header="Student Pic" body={studentNameWithImageTemplate} />
                                <Column
                                    field="StudentName"
                                    header="Student Name"
                                />
                                <Column
                                    body={attendanceDateBodyTemplate}
                                    header="Submitted On"
                                />
                                <Column
                                    field='TakenBy'
                                    header="Submitted By"
                                />
                                <Column
                                    body={attendanceBodyTemplate}
                                    header="Attendance"
                                />
                            </DataTable>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
            <Dialog
                header={attendanceList ? `${attendanceList[0]?.ClassName} (${attendanceList[0]?.SubjectName} - ${classTime})` : ''}
                visible={isStudentView}
                onHide={() => {
                    setIsStudentView(false);
                    setClassTime('');
                    setAttendanceList([]);
                }}
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
            >
                <div className="p-ai-center">
                    <DataTable
                        value={attendanceList}
                        paginator
                        rows={childRows}
                        first={childFirst}
                        filterDisplay="menu"
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onPage={onChildPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column
                            field="RollNo"
                            header="Roll No"
                        />
                        <Column header="Student Pic" body={studentNameWithImageTemplate} />
                        <Column
                            field="StudentName"
                            header="Student Name"
                        />
                        <Column
                            field="Attendance"
                            body={attendanceBodyTemplate}
                        />
                    </DataTable>
                </div>
            </Dialog>
        </div>
    );
};

export default Attendance;
